export interface QuizConfig {
  sectionRetakeThreshold: number;
  passingScore: number;
  maxRetakeAttempts: number | null;
  requireEmail: boolean;
  geminiApiKey?: string;
  apiBaseUrl?: string;
}

export const DEFAULT_CONFIG: QuizConfig = {
  sectionRetakeThreshold: 0.5,
  passingScore: 1.0,
  maxRetakeAttempts: null,
  requireEmail: true,
  geminiApiKey: process.env.REACT_APP_GEMINI_API_KEY,
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '/api',
};

export const getConfig = (): QuizConfig => {
  const storedConfig = localStorage.getItem('quiz-config');
  if (storedConfig) {
    try {
      return { ...DEFAULT_CONFIG, ...JSON.parse(storedConfig) };
    } catch (error) {
      console.warn('Failed to parse stored config, using defaults:', error);
      return DEFAULT_CONFIG;
    }
  }
  return DEFAULT_CONFIG;
};

export const updateConfig = (newConfig: Partial<QuizConfig>): void => {
  const currentConfig = getConfig();
  const updatedConfig = { ...currentConfig, ...newConfig };
  localStorage.setItem('quiz-config', JSON.stringify(updatedConfig));
};